import React, { useState } from 'react';
import { StandBoardList } from './StandBoardList';
import { ClubFeederBoard, ClubFeedTotalCard, ClubMarkerPanel } from './ClubFeederBoard';
import { ClubAreaBoard } from './ClubAreaBoard';
import { ClubLogFillDialog } from './ClubLogFillDialog';
import { ClubSharedPlansPanel } from '../../clubs/components/ClubSharedPlansPanel';
import './ClubMapBoards.css';

/**
 * Stand and feeder columns sit under the map; areas (tracts + fields) span below.
 */
export function ClubMapBoards({
  stands = [],
  feeders = [],
  markers = [],
  currentUserId = null,
  selectedStandId = null,
  hoveredWaypointId = null,
  onHoverWaypoint,
  onSelectStand,
  onEditWaypoint,
  onMoveWaypoint,
  onDeleteWaypoint,
  boundaries = [],
  selectedAreaId = null,
  onSelectArea,
  onEditArea,
  onEditAreaShape,
  onDeleteArea,
  onEditView,
  seasonLbs = 0,
  memberCount = null,
  memberName = '',
  clubName = '',
  clubId = null,
  onFillLogged,
  now,
}) {
  const [logStation, setLogStation] = useState(null);

  return (
    <div className="club-map-tab__boards" data-testid="club-map-boards">
      <div className="club-map-tab__board-col" data-testid="club-map-stands-col">
        <StandBoardList
          stands={stands}
          currentUserId={currentUserId}
          selectedStandId={selectedStandId}
          hoveredWaypointId={hoveredWaypointId}
          onHoverWaypoint={onHoverWaypoint}
          onSelectStand={onSelectStand}
          onEditStand={onEditWaypoint}
          onMoveStand={onMoveWaypoint}
          onDeleteStand={onDeleteWaypoint}
        />
        <ClubMarkerPanel
          markers={markers}
          onEditWaypoint={onEditWaypoint}
          onMoveWaypoint={onMoveWaypoint}
          onDeleteWaypoint={onDeleteWaypoint}
        />
      </div>
      <div className="club-map-tab__board-col" data-testid="club-map-feeders-col">
        <ClubFeederBoard
          feeders={feeders}
          hoveredWaypointId={hoveredWaypointId}
          onHoverWaypoint={onHoverWaypoint}
          onLogFill={setLogStation}
          onEditWaypoint={onEditWaypoint}
          onMoveWaypoint={onMoveWaypoint}
          onDeleteWaypoint={onDeleteWaypoint}
          now={now}
        />
        {feeders.length > 0 ? (
          <ClubFeedTotalCard
            stationCount={feeders.length}
            seasonLbs={seasonLbs}
            memberCount={memberCount}
          />
        ) : null}
        <ClubSharedPlansPanel clubId={clubId} clubName={clubName} variant="board" />
      </div>
      <div className="club-map-tab__areas" data-testid="club-map-areas-col">
        <ClubAreaBoard
          boundaries={boundaries}
          selectedAreaId={selectedAreaId}
          onSelectArea={onSelectArea}
          onEditArea={onEditArea}
          onEditAreaShape={onEditAreaShape}
          onDeleteArea={onDeleteArea}
          onEditView={onEditView}
        />
      </div>
      <ClubLogFillDialog
        show={Boolean(logStation)}
        station={logStation}
        clubName={clubName}
        memberCount={memberCount || 0}
        memberName={memberName}
        onHide={() => setLogStation(null)}
        onLogged={onFillLogged}
      />
    </div>
  );
}

export default ClubMapBoards;
